import { createFileRoute, redirect } from '@tanstack/react-router'
import { CustomerHubRedirect } from './-ui/customer-hub-redirect'

// Заказчик живёт на хабе своей компании: /projects — legacy deep-link, уводим на
// таб «Проекты» хаба. Сотрудника — на доску.
export const Route = createFileRoute('/_app/projects')({
  beforeLoad: ({ context }) => {
    if (context.session?.kind === 'employee') throw redirect({ to: '/boards' })
  },
  head: () => ({ meta: [{ title: 'Проекты · STIT Deal' }] }),
  component: () => <CustomerHubRedirect tab="projects" />,
})
